// @flow

import React from "react";
import { localize } from "redux-i18n";

import { ChartJS } from "@components";

type OwnProps = $Exact<{
  reportData: *,
  title: string,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const CurrentAbsenceStatusDepartments = ({ reportData, title, t }: Props) => {
  return (
    <ChartJS
      type="bar"
      title={title}
      className="mb-4"
      data={{
        labels: (reportData || []).map(([label]) => label),
        datasets: [
          { label: t("SHORT_TERM_ABSENCE"), data: (reportData || []).map(([, s]) => s) },
          { label: t("LONG_TERM_ABSENCE"), data: (reportData || []).map(([, , l]) => l) },
        ],
      }}
      options={{ height: 300, isStacked: true, wrapXAxisLabels: true }}
    />
  );
};

export default localize()(CurrentAbsenceStatusDepartments);
